import { render, staticRenderFns } from "./StockDetailTemplate.vue?vue&type=template&id=83b4c93a"
import script from "./StockDetailTemplate.vue?vue&type=script&lang=js"
export * from "./StockDetailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports